module.exports = __webpack_public_path__ + "img/teaser_training5.3157d55e.jpg";